import { render, staticRenderFns } from "./mQues.vue?vue&type=template&id=ef6b82ea&scoped=true&"
import script from "./mQues.vue?vue&type=script&lang=js&"
export * from "./mQues.vue?vue&type=script&lang=js&"
import style0 from "./mQues.vue?vue&type=style&index=0&id=ef6b82ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef6b82ea",
  null
  
)

export default component.exports